// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"2b7cd2c1","485":"5c40a200"}[chunkId] + ".chunk.js";
};